export const contactNumberValidation = new RegExp(/^\+[1-9]\d{6,14}$/)
export const specitalInstructionsValidation = new RegExp(
  /^[\w\r\n .,&!?+:/-]{1,2000}$/,
)
export const flightNumberValidation = new RegExp(
  /^[A-Z0-9]{2,3}\s?-?\s?\d{1,4}[A-Z]?$/i,
)
